import { Mol } from '@moleculeone/types';
import { SVGMol, SVGMolSpace } from '@moleculeone/ui';
import React from 'react';

import { styled } from '../../../../../stitches.config';
import { Space } from '../../hooks/useCompoundEditor';
import { Selection } from '../Selection/Selection';

export const MENU = 'MENU';
export const ELEMENT = 'ELEMENT';
export const HOTKEYS = 'HOTKEYS';
export const FRAGMENT = 'FRAGMENT';
export const PICKER = 'PICKER';

const StyledSVGMolSpace = styled(SVGMolSpace, {
  'height': '100%',
  'width': '100%',

  '& .fo-mol-background': {
    display: 'none',
  },

  '& .mol': {
    opacity: 1,
  },

  '&:hover .mol': {
    transition: 'opacity 0.2s ease',
  },

  '& .preview-mol': {
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },

  '&:hover .preview-mol': {
    opacity: 1,
  },

  'variants': {
    hasPreview: {
      true: {
        '&:hover .mol': {
          opacity: 0,
        },
      },
    },
  },
});

type DrawingSpaceProps = Space & {
  className?: string;
  onContextMenuOpen: (event: any) => void;
  onMolUpdate?: (mol: Mol) => void;
};

export function DrawingSpace(props: DrawingSpaceProps) {
  const {
    className,
    onContextMenuOpen,
    onMolUpdate = () => {},
    mol,
    drawnMol,
    loop,
    viewport,
    svgPreview,
    onMouseEvent,
  } = props;

  React.useEffect(() => {
    // @ts-ignore
    window.mol = mol;
    onMolUpdate(mol);
  }, [JSON.stringify(mol)]);

  return (
    <StyledSVGMolSpace
      className={className}
      hasPreview={!!svgPreview}
      onMouseEvent={onMouseEvent}
      // @ts-ignore
      onContextMenu={
        typeof onContextMenuOpen === 'function'
          ? event => {
              onContextMenuOpen(event);
            }
          : () => {}
      }
      viewport={viewport}
    >
      <SVGMol drawnMol={drawnMol} className="mol" />
      <Selection points={loop} />
      {svgPreview && <SVGMol preview drawnMol={svgPreview} className="preview-mol" />}
    </StyledSVGMolSpace>
  );
}
